<template>
<svg width="24px" height="24px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <g stroke="none" stroke-width="1" fill="currentColor" fill-rule="evenodd">
    <rect id="Rectangle" y="10.714" width="24" height="2.571"></rect>
  </g>
</svg>
</template>
